
export const ACCEPT_ANY_IMAGE = ".jpg, .jpeg, .png, .gif, .svg, .webp";
export const ACCEPT_IMAGE = ".jpg, .jpeg, .png, .webp";